import { useQuery } from "@tanstack/react-query";
import { supabaseV2 } from "./supabase";
import type { UserDisplay } from "../types";

// Risolve un set di user_id in {id, email, full_name} via RPC list_users_display.
// Cache batchata: chiama la RPC una sola volta per l'intero set di user_id (deduplicati e
// ordinati). Usato per mostrare "Creata da X" senza N+1 query.
export function useUsersDisplay(userIds: Array<string | null | undefined>) {
  const uniqueIds = Array.from(
    new Set(userIds.filter((id): id is string => !!id)),
  ).sort();
  const cacheKey = uniqueIds.join("|");
  const query = useQuery({
    queryKey: ["users-display", cacheKey],
    queryFn: async () => {
      if (uniqueIds.length === 0) return new Map<string, UserDisplay>();
      const { data, error } = await supabaseV2.rpc("list_users_display", {
        _user_ids: uniqueIds,
      });
      if (error) throw error;
      const map = new Map<string, UserDisplay>();
      for (const row of (data || []) as UserDisplay[]) map.set(row.id, row);
      return map;
    },
    staleTime: 5 * 60_000,
    enabled: uniqueIds.length > 0,
  });
  return query.data || new Map<string, UserDisplay>();
}

// Etichetta breve "Andrea Camolese" o fallback su email locale ("andrea") se manca il nome.
export function userShortName(u: UserDisplay | undefined | null): string {
  if (!u) return "—";
  if (u.full_name) return u.full_name;
  if (u.email) return u.email.split("@")[0];
  return u.id.slice(0, 8);
}
